var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('generic-page',{attrs:{"image":_vm.mainImageUrl,"image-height":"95vh"}},[_c('news-card',{attrs:{"item":_vm.content}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }